import { ArchiveLockOpenOutlineIcon } from './ArchiveLockOpenOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 5128174B-10F3-4057-96AE-4DD993B4317F
 * name archive-lock-open-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-lock-open-outline.svg
 * tags
 * - Lock 
 */
export const BoxLockOpenOutlineIcon = ArchiveLockOpenOutlineIcon;
export default BoxLockOpenOutlineIcon